import PropTypes from "prop-types"
import { NOTIFICATION_TYPES } from "./helpers"

export const NOTIFICATION = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)).isRequired,
  accountId: PropTypes.string.isRequired,
  userId: PropTypes.string,
  data: PropTypes.object,
  total: PropTypes.number.isRequired,
  success: PropTypes.number,
  error: PropTypes.number,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
})
